import { connect } from 'react-redux';
import { IStoreState } from 'store';
//
import ParetoAddDealModal from 'pages/pareto/add-deal-modal/pareto-add-deal-modal';
import {
  setParetoDealIds,
  setParetoIsModalOpen,
  setParetoDealFilter,
  setParetoRegionFilter,
  setParetoProductLineFilter,
  setParetoSearchKeyword,
} from 'store/pareto/actions';
import { IParetoState, EParetoDealFilter } from 'store/pareto/types';
import { IDeal } from 'store/deals/types';
import { getAvailableProductLines, getFilteredDeals, getAvailableRegions } from 'pages/pareto/add-deal-modal/selectors';
import { IFieldOption } from 'store/field-options/types';
import { setPortfolioDealIds } from 'store/portfolio/actions';
import { EModalTitle } from 'lib/storage';

export interface IParetoAddDealModalStateProps extends IParetoState {
  filteredDeals: IDeal[];
  availableRegions: IFieldOption[];
  availableProductLines: IFieldOption[];
  modalTitle: EModalTitle;
}

export interface IParetoAddDealModalDispatchProps {
  setParetoDealIds: (paretoDealIds: string[]) => void;
  setParetoIsModalOpen: (isModalOpen: boolean, title: EModalTitle) => void;
  setParetoDealFilter: (dealFilter: EParetoDealFilter) => void;
  setParetoRegionFilter: (regionFilter: string) => void;
  setParetoProductLineFilter: (productLineFilter: string) => void;
  setParetoSearchKeyword: (searchKeyword: string) => void;
  setPortfolioDealIds: (paretoDealIds: string[]) => void;
}

export type TParetoAddDealModalProps = IParetoAddDealModalStateProps & IParetoAddDealModalDispatchProps;

const mapStateToProps = (state: IStoreState): IParetoAddDealModalStateProps => ({
  paretoDealIds: state.pareto.paretoDealIds,
  paretoDeals: state.pareto.paretoDeals,
  dealFilter: state.pareto.dealFilter,
  regionFilter: state.pareto.regionFilter,
  productLineFilter: state.pareto.productLineFilter,
  searchKeyword: state.pareto.searchKeyword,
  isModalOpen: state.pareto.isModalOpen,
  modalTitle: state.pareto.modalTitle,
  filteredDeals: getFilteredDeals(state),
  availableProductLines: getAvailableProductLines(state),
  availableRegions: getAvailableRegions(state),
  hasVolumeWidthBars: state.pareto.hasVolumeWidthBars,
  portfolioDealIds: state.pareto.portfolioDealIds,
  portfolioDeals: state.pareto.portfolioDeals,
});

const mapDispatchToProps = {
  setParetoDealIds,
  setParetoIsModalOpen,
  setParetoDealFilter,
  setParetoRegionFilter,
  setParetoProductLineFilter,
  setParetoSearchKeyword,
  setPortfolioDealIds,
};

export default connect(mapStateToProps, mapDispatchToProps)(ParetoAddDealModal);
